const set = require('regenerate')(0x301, 0x304, 0x307, 0x311, 0x313, 0x35E);
set.addRange(0x105C0, 0x105F3);
exports.characters = set;
